import { Stack } from "@mui/material";
import React from "react";
import { StyledCell, StyledStack } from "./styles";
import { HubHookFormInput, HubHookFormSelect, HubIcon } from "../../components";
import { Formats, getLabels } from "./helper";
import { useFormContext } from "react-hook-form";

const BarcodeValueTableRow = ({ idx, item, remove = () => {} }) => {
  const prefix = `barcode.${idx}`;
  const { watch } = useFormContext();

  const format = watch(`${prefix}.format`);
  const formatNumbers = format === 2;

  return (
    <Stack backgroundColor="hubColors.white">
      <StyledStack>
        <HubHookFormSelect
          name={`${prefix}.field`}
          defaultValue={item.field}
          options={getLabels(1)}
          required
        />
        <HubHookFormSelect
          name={`${prefix}.format`}
          defaultValue={item.format}
          options={Formats}
          useDefault
          required
        />
        {formatNumbers ? (
          <HubHookFormInput
            name={`${prefix}.padding`}
            defaultValue={item.padding}
            placeholder="# of numbers"
            isNumber
          />
        ) : (
          <StyledCell />
        )}
        <StyledCell onClick={() => remove(idx)}>
          <HubIcon icon="X" size="10px" />
        </StyledCell>
      </StyledStack>
    </Stack>
  );
};

export default BarcodeValueTableRow;
